var React = require('react');

var ComponentRow = require('components/manage/pages/components/component_row');

class GroupComponentRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: true,
      isOverridden: this.props.componentGroup.is_overridden,
      parentComponentStatus: this.props.componentGroup.status,
      childStatuses: this._buildInitialChildStatuses()
    };
  }

  _buildInitialChildStatuses() {
    // Since we're not always updating async, a group row has to keep up with the current
    // status of all of its children, regardless of whether or not we've hit the sever.
    return this.props.componentGroup.components.map(component => {
      return {
        id: component.id,
        status: component.status
      }
    });
  }

  _updateChildStatus(componentId, newStatus) {
    // The group needs to know of a status change in the view, so we
    // can update the derived group status accordingly.
    var updateStatuses = this.state.childStatuses;

    // Insert the new status in place of the old
    var index = _.indexOf(updateStatuses, _.find(updateStatuses, {id: componentId}));
    updateStatuses.splice(index, 1, {id: componentId, status: newStatus});

    // Have the group determine its own derived status unless it is overridden
    if(!this.state.isOverridden) {
      this._determineGroupDerivedStatus();
    }
  }

  _determineGroupDerivedStatus() {
    // Update the parent's group accordingly based on the status of its children
    var comparatorStatuses = this.state.childStatuses.map(component => component.status);
    var updateStatus;

    if ( _.contains(comparatorStatuses, 'operational' )) {updateStatus = 'operational';}
    if ( _.contains(comparatorStatuses, 'under_maintenance' )) {updateStatus = 'under_maintenance';}
    if ( _.contains(comparatorStatuses, 'degraded_performance' )) {updateStatus = 'degraded_performance';}
    if ( _.contains(comparatorStatuses, 'partial_outage' )) {updateStatus = 'partial_outage';}
    if ( _.contains(comparatorStatuses, 'major_outage' )) {updateStatus = 'major_outage';}

    this.setState({parentComponentStatus: updateStatus});
  }

  _toggleChildren() {
    this.setState({showChildren: !this.state.showChildren});
  }

  _toggleOverridden() {
    this.setState({isOverridden: !this.state.isOverridden});
  }

  _displayChildren() {
    if (this.state.showChildren) {
      return (
        <div className="child-components-container">
          {this.props.componentGroup.components.map(component => {
            return (
              <ComponentRow key={component.id}
                            pageParam={this.props.pageParam}
                            currentStatus={component.status}
                            component={component}
                            componentStatuses={this.props.componentStatuses}
                            isChild={true}
                            informParent={this._updateChildStatus.bind(this)}
                            shouldAutoUpdate={this.props.shouldAutoUpdate}/>
            );
          })}
        </div>
      );
    }
  }

  render() {
    return (
      <div className="component-group-outer-container">
        <ComponentRow key={this.props.componentGroup.id}
                      onClick={this._toggleChildren.bind(this)}
                      visible={this.state.showChildren}
                      pageParam={this.props.pageParam}
                      currentStatus={this.state.parentComponentStatus}
                      component={this.props.componentGroup}
                      componentStatuses={this.props.componentStatuses}
                      toggleOverridden={this._toggleOverridden.bind(this)}
                      shouldAutoUpdate={this.props.shouldAutoUpdate}
                      informParent={this._determineGroupDerivedStatus.bind(this)}
                      isGroupParent={true}/>

        { this._displayChildren() }
      </div>
    );
  }
}

module.exports = GroupComponentRow;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/group_component_row.jsx